var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('b-input',{ref:"locationSearch",staticClass:"form-control",attrs:{"type":"text","placeholder":"Search address"},on:{"changed":_vm.changed}})],1),_c('div',{ref:"map",staticStyle:{"height":"100vw","width":"auto"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }